import { useMutation, useQueryClient } from 'react-query';

import type { IStandardErrorResponse } from 'src/api/common';
import { useNotifications } from 'src/notifications';
import { queryKeys } from 'src/services/api/constants';
import { apiClient } from 'src/services/api/client';
import { getApiErrorMessage } from 'src/services/api/utils';
import { LANDLORD_SELF_INVITE_PATH } from 'src/services/api/onboarding/invites/constants';

export const useDeleteInvite = (inviteId: number) => {
    const queryClient = useQueryClient();
    const { addNotification } = useNotifications();

    return useMutation<
        void,
        IStandardErrorResponse
    >(
        async () => {
            await apiClient(`${LANDLORD_SELF_INVITE_PATH}/${inviteId}`, {
                method: 'delete',
            });
        }, {
            onSuccess: () => {
                addNotification('Invite deleted', 'success');
                queryClient.invalidateQueries(queryKeys.onboardingInvites);
            }, onError: (error) => {
                const errorMessage = getApiErrorMessage(error) || 'Failed to delete invite';
                addNotification(errorMessage, 'error');
            }
        });
};